var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 13.3333C0.966667 13.3333 0.652778 13.2028 0.391667 12.9417C0.130556 12.6806 0 12.3667 0 12V2.66667C0 2.3 0.130556 1.98611 0.391667 1.725C0.652778 1.46389 0.966667 1.33333 1.33333 1.33333H4.13333C4.27778 0.933333 4.51944 0.611111 4.85833 0.366667C5.19722 0.122222 5.57778 0 6 0C6.42222 0 6.80278 0.122222 7.14167 0.366667C7.48056 0.611111 7.72222 0.933333 7.86667 1.33333H10.6667C11.0333 1.33333 11.3472 1.46389 11.6083 1.725C11.8694 1.98611 12 2.3 12 2.66667V12C12 12.3667 11.8694 12.6806 11.6083 12.9417C11.3472 13.2028 11.0333 13.3333 10.6667 13.3333H1.33333ZM1.33333 12H10.6667V2.66667H1.33333V12ZM2.66667 10.6667H7.33333V9.33333H2.66667V10.6667ZM2.66667 8H9.33333V6.66667H2.66667V8ZM2.66667 5.33333H9.33333V4H2.66667V5.33333ZM6 2.16667C6.14444 2.16667 6.26389 2.11944 6.35833 2.025C6.45278 1.93056 6.5 1.81111 6.5 1.66667C6.5 1.52222 6.45278 1.40278 6.35833 1.30833C6.26389 1.21389 6.14444 1.16667 6 1.16667C5.85556 1.16667 5.73611 1.21389 5.64167 1.30833C5.54722 1.40278 5.5 1.52222 5.5 1.66667C5.5 1.81111 5.54722 1.93056 5.64167 2.025C5.73611 2.11944 5.85556 2.16667 6 2.16667Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignment);
export default __webpack_public_path__ + "static/media/Assignment.3e509936f7f4366fc87d56a7697f87ce.svg";
export { ForwardRef as ReactComponent };